import "bootstrap/dist/css/bootstrap.min.css";
import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { Row, Col } from "reactstrap";
import { ValidatorForm, TextValidator } from "react-material-ui-form-validator";
import { ToastContainer, toast, Flip } from "react-toastify";
import { toastConfig } from "../Custom/ToastConfig";
import CustomSpinner from "../Custom/spinner";
import ResetPassword from "../Login/ResetPassword";
import { userLoginDetails, createRegisterUser } from "../../actions/index";
import "../../css/LoginModal.css";
import "../../css/toastify.css";
import "react-toastify/dist/ReactToastify.css";

class ClassesLoginSignup extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeTab: "login", // 'login' | 'signup' | 'reset_password'

      // Login form state
      loginEmail: "",
      loginPassword: "",

      // Signup form state
      signupName: "",
      signupMobile: "",
      signupEmail: "",
      signupPassword: "",

      loading: false,
    };
  }

  componentDidMount() {
    window.scrollTo(0, 0);

    // If user is already logged in, redirect directly to classes
    const token = localStorage.getItem("token");
    if (token) {
      this.props.history.push("/classes");
    }
  }

  // Handle Login submission
  handleLogin = () => {
    const { loginEmail, loginPassword } = this.state;
    this.setState({ loading: true });

    const payload = {
      email: loginEmail,
      password: loginPassword,
    };

    fetch("https://d1dgpoid6t01jm.cloudfront.net/user/userLogin", {
      method: "POST",
      cache: "no-cache",
      credentials: "same-origin",
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*",
        "Accept-Encoding": "gzip",
      },
      body: JSON.stringify(payload),
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.success) {
          const user = data.response.user;
          localStorage.setItem("token", data.response.authorisation.token);
          localStorage.setItem("user_id", user.id);
          localStorage.setItem("user_type", user.type);
          localStorage.setItem("name", user.name);
          localStorage.setItem("mobile", user.mobile);
          localStorage.setItem("email", user.email);

          this.props.storeUserDetail(user);

          // For this particular flow: redirect straight to classes to complete checkout
          this.props.history.push("/classes");
        } else if (data.message) {
          toast(data.message, toastConfig);
          this.setState({ loading: false });
        }
      })
      .catch((err) => {
        toast(err.message, toastConfig);
        this.setState({ loading: false });
      });
  };

  // Handle Signup submission
  handleSignup = () => {
    const { signupName, signupMobile, signupEmail, signupPassword } =
      this.state;

    this.setState({ loading: true });

    const payload = {
      fullname: signupName.trim(),
      mobile: signupMobile.trim(),
      email: signupEmail.trim(),
      password: signupPassword,
    };

    fetch("https://d1dgpoid6t01jm.cloudfront.net/user/userRegister", {
      method: "POST",
      cache: "no-cache",
      credentials: "same-origin",
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*",
        "Accept-Encoding": "gzip",
      },
      body: JSON.stringify(payload),
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.success) {
          toast("Registered Successfully! Logging in...", toastConfig);

          // Automatically log the newly registered user in
          const loginPayload = {
            email: signupEmail.trim(),
            password: signupPassword,
          };

          fetch("https://d1dgpoid6t01jm.cloudfront.net/user/userLogin", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              "Access-Control-Allow-Origin": "*",
              "Accept-Encoding": "gzip",
            },
            body: JSON.stringify(loginPayload),
          })
            .then((r) => r.json())
            .then((loginData) => {
              if (loginData.success) {
                const user = loginData.response.user;
                localStorage.setItem(
                  "token",
                  loginData.response.authorisation.token
                );
                localStorage.setItem("user_id", user.id);
                localStorage.setItem("user_type", user.type);
                localStorage.setItem("name", user.name);
                localStorage.setItem("mobile", user.mobile);
                localStorage.setItem("email", user.email);

                this.props.storeUserDetail(user);
                this.props.history.push("/classes");
              } else {
                // If auto-login fails, switch to login tab with email prefilled
                this.setState({
                  activeTab: "login",
                  loginEmail: signupEmail,
                  loginPassword: signupPassword,
                  loading: false,
                });
              }
            })
            .catch(() => {
              this.setState({
                activeTab: "login",
                loginEmail: signupEmail,
                loginPassword: signupPassword,
                loading: false,
              });
            });
        } else if (data.errors) {
          const errors = data.errors;
          Object.keys(errors).forEach((field) => {
            errors[field].forEach((msg) => {
              toast(`${field.charAt(0).toUpperCase() + field.slice(1)}: ${msg}`, toastConfig);
            });
          });
          this.setState({ loading: false });
        } else if (data.message) {
          toast(data.message, toastConfig);
          this.setState({ loading: false });
        }
      })
      .catch((err) => {
        toast(err.message, toastConfig);
        this.setState({ loading: false });
      });
  };

  render() {
    const { activeTab, loading } = this.state;

    return (
      <div>
        <div className="login">
          <div className="col-sm-12">
            <div className="container-row">
              <div className="col-sm-12 col-md-6 col-lg-4 modal-container">
                {/* 1. Login Section */}
                {activeTab === "login" && (
                  <div>
                    <h2 style={{ color: "white", textAlign: "center" }}>
                      Login to get fit
                    </h2>
                    <Row>
                      <Col sm="12">
                        <div className="modalcontainer">
                          <ValidatorForm onSubmit={this.handleLogin}>
                            <div className="form-group">
                              <div className="inputfield">
                                <TextValidator
                                  type="email"
                                  className="form-control"
                                  placeholder="Email *"
                                  name="loginEmail"
                                  value={this.state.loginEmail}
                                  validators={["required", "isEmail"]}
                                  errorMessages={["Valid Email is required"]}
                                  onChange={(e) =>
                                    this.setState({
                                      loginEmail: e.target.value,
                                    })
                                  }
                                />
                              </div>
                            </div>

                            <div className="form-group">
                              <div className="inputfield">
                                <TextValidator
                                  type="password"
                                  className="form-control"
                                  placeholder="Password *"
                                  name="loginPassword"
                                  validators={["required"]}
                                  errorMessages={["Password is required"]}
                                  value={this.state.loginPassword}
                                  onChange={(e) =>
                                    this.setState({
                                      loginPassword: e.target.value,
                                    })
                                  }
                                />
                              </div>
                            </div>

                            <center className="bottom">
                              <button
                                type="submit"
                                style={{
                                  background: "black",
                                  color: "#E9C589",
                                }}
                                className="servie-link button-slanted nav-link"
                              >
                                <span className="button-slanted-content">
                                  Login
                                </span>
                              </button>
                            </center>
                          </ValidatorForm>
                        </div>
                      </Col>
                    </Row>
                  </div>
                )}

                {/* 2. Signup Section */}
                {activeTab === "signup" && (
                  <div>
                    <h2 style={{ color: "white", textAlign: "center" }}>
                      Register to get fit
                    </h2>
                    <Row>
                      <Col sm="12">
                        <div className="modalcontainer">
                          <ValidatorForm
                            onSubmit={this.handleSignup}
                            className="login"
                          >
                            <div className="form-group">
                              <div className="inputfield">
                                <TextValidator
                                  type="text"
                                  placeholder="Name *"
                                  className="form-control"
                                  name="signupName"
                                  value={this.state.signupName}
                                  onChange={(e) =>
                                    this.setState({
                                      signupName: e.target.value,
                                    })
                                  }
                                  validators={["required"]}
                                  errorMessages={["Name is required"]}
                                />
                              </div>
                            </div>

                            <div className="form-group">
                              <div className="inputfield">
                                <TextValidator
                                  type="text"
                                  placeholder="Phone Number *"
                                  className="form-control"
                                  name="signupMobile"
                                  value={this.state.signupMobile}
                                  onChange={(e) =>
                                    this.setState({
                                      signupMobile: e.target.value,
                                    })
                                  }
                                  validators={[
                                    "required",
                                    "matchRegexp:^\\d{10}$",
                                  ]}
                                  errorMessages={[
                                    "Please enter a valid phone number along with code",
                                    "Phone number must be 10 digits",
                                  ]}
                                />
                              </div>
                            </div>

                            <div className="form-group">
                              <div className="inputfield">
                                <TextValidator
                                  type="email"
                                  placeholder="Email *"
                                  className="form-control"
                                  name="signupEmail"
                                  value={this.state.signupEmail}
                                  onChange={(e) =>
                                    this.setState({
                                      signupEmail: e.target.value,
                                    })
                                  }
                                  validators={["required", "isEmail"]}
                                  errorMessages={["Valid Email is required"]}
                                />
                              </div>
                            </div>

                            <div className="form-group">
                              <div className="inputfield">
                                <TextValidator
                                  type="password"
                                  className="form-control"
                                  placeholder="Password *"
                                  name="signupPassword"
                                  value={this.state.signupPassword}
                                  onChange={(e) =>
                                    this.setState({
                                      signupPassword: e.target.value,
                                    })
                                  }
                                  validators={["required"]}
                                  errorMessages={[
                                    "Please enter a password with 6 or more characters",
                                  ]}
                                />
                              </div>
                            </div>

                            <center className="bottom">
                              <button
                                type="submit"
                                style={{
                                  background: "black",
                                  color: "#E9C589",
                                }}
                                className="servie-link button-slanted nav-link"
                              >
                                <span className="button-slanted-content">
                                  Register
                                </span>
                              </button>
                            </center>
                          </ValidatorForm>
                        </div>
                      </Col>
                    </Row>
                  </div>
                )}

                {/* 3. Reset Password Section */}
                {activeTab === "reset_password" && (
                  <ResetPassword
                    onResetSuccess={() =>
                      this.setState({ activeTab: "login" })
                    }
                  />
                )}

                <br />

                {/* Navigation switchers between Login, Signup & Forgot Password */}
                {activeTab === "login" ? (
                  <div>
                    <center style={{ color: "white", fontFamily: "Roboto" }}>
                      Not a member !{" "}
                      <span
                        style={{
                          color: "#E9C589",
                          fontWeight: 600,
                          cursor: "pointer",
                        }}
                        onClick={() =>
                          this.setState({ activeTab: "signup" })
                        }
                      >
                        Sign Up{" "}
                      </span>
                      Now
                    </center>
                    <center style={{ marginTop: "10px" }}>
                      <span
                        style={{
                          fontWeight: 600,
                          cursor: "pointer",
                          color: "#E9C589",
                          paddingTop: "20px",
                        }}
                        onClick={() =>
                          this.setState({ activeTab: "reset_password" })
                        }
                      >
                        Forgot Password
                        <span style={{ fontFamily: "Roboto" }}>?</span>
                      </span>
                    </center>
                  </div>
                ) : activeTab === "signup" ? (
                  <center style={{ color: "white", fontFamily: "Roboto" }}>
                    Existing member !{" "}
                    <span
                      style={{
                        color: "#E9C589",
                        fontWeight: 600,
                        cursor: "pointer",
                      }}
                      onClick={() =>
                        this.setState({ activeTab: "login" })
                      }
                    >
                      Login{" "}
                    </span>
                    Now
                  </center>
                ) : (
                  <center style={{ color: "white", fontFamily: "Roboto" }}>
                    Remember your password ?{" "}
                    <span
                      style={{
                        color: "#E9C589",
                        fontWeight: 600,
                        cursor: "pointer",
                      }}
                      onClick={() =>
                        this.setState({ activeTab: "login" })
                      }
                    >
                      Login{" "}
                    </span>
                    Now
                  </center>
                )}
              </div>

              {/* Right Side Image */}
              <div className="col-sm-6">
                <img
                  src={require("../../assests/login-image.png")}
                  className="login_background"
                  alt="Fitfinity Login"
                />
              </div>
            </div>
          </div>
        </div>

        <ToastContainer transition={Flip} />
        {loading && <CustomSpinner spinnerVal={true} />}
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch) => ({
  storeUserDetail: (details) => dispatch(userLoginDetails(details)),
  storeRegisterUser: (user) => dispatch(createRegisterUser(user)),
});

export default withRouter(
  connect(null, mapDispatchToProps)(ClassesLoginSignup)
);
